// src/api/reservationApi.js
import { apiClient } from "./ApiClient";

// 1. List all reservations of a given type
export const retrieveAllReservationsApi = (reservationType) =>
  apiClient.get(`/reservation-view/reservations/${reservationType}`);

// 2. Get one reservation by its ID
export const retrieveReservationByIdApi = (reservationId) =>
  apiClient.get(`/reservation-view/reservations/get/${reservationId}`);

// 3. Create a new reservation
export const createReservationApi = (reservation) =>
  apiClient.post(`/reservation-view/add`, reservation);

// 4. Update an existing reservation
export const updateReservationApi = (reservationId, reservation) =>
  apiClient.put(`/reservation-view/edit/${reservationId}`, reservation);

export const retrieveFilteredReservedOrdersApi = (reservation) =>
  apiClient.post(`/reservation-view/reserved-orders/filter`, reservation);

// 5. Soft-delete (or deactivate) a list of reservations
export const cancelReservationApi = (reservationId) =>
  apiClient.put(`/reservation-view/cancel/${reservationId}`);
